var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTw(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
    fill: "#ACB1B6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5293 9.59033C16.5339 9.69593 16.5339 9.79673 16.5339 9.90233C16.5386 13.1039 14.1863 16.8 9.8847 16.8C8.61597 16.8 7.3704 16.4207 6.30078 15.7103C6.486 15.7343 6.67121 15.7439 6.85643 15.7439C7.90752 15.7439 8.93084 15.3791 9.75968 14.7023C8.75951 14.6831 7.87974 14.0063 7.57414 13.0175C7.92605 13.0895 8.28722 13.0751 8.62986 12.9743C7.54172 12.7535 6.75919 11.7599 6.75456 10.6031C6.75456 10.5935 6.75456 10.5839 6.75456 10.5743C7.07869 10.7615 7.44449 10.8671 7.81492 10.8767C6.7916 10.1663 6.47211 8.75033 7.09258 7.64152C8.28258 9.15833 10.0329 10.0751 11.9128 10.1759C11.723 9.33593 11.9823 8.45272 12.5888 7.85752C13.5288 6.94072 15.0105 6.98872 15.8996 7.96312C16.4228 7.85752 16.9275 7.65592 17.3859 7.37272C17.21 7.93432 16.8442 8.40952 16.358 8.71193C16.821 8.65432 17.2748 8.52472 17.7008 8.33272C17.3859 8.82233 16.9877 9.24473 16.5293 9.59033Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTw);
export default __webpack_public_path__ + "static/media/tw.1872bf213d9cd0a67eb6cc73fa975b14.svg";
export { ForwardRef as ReactComponent };